import { useEffect, useState } from "react";
import Auth from "../../Auth";
import AIFunctionsMain from "./Main";

function AIFunctions({ user }) {
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthorization = async () => {
      if (!user) {
        return;
      }
      setLoading(true);
      try {
        const access = await Auth.fetchWithIdToken("/api/admin/access");
        setAuthorized(access.admin);
      } catch (error) {
        console.error("Error checking ai function authorization:", error);
      } finally {
        setLoading(false);
      }
    };

    checkAuthorization();
  }, [user]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authorized) {
    return <div>You are not authorized to access this page</div>;
  }

  return <AIFunctionsMain />;
}

export default AIFunctions;
